import { useQuery } from "@tanstack/react-query";

import { getCropMixComposerSettings } from "services";

import { useUserContext } from "utils";

import { GET_CROP_MIX_COMPOSER_SETTINGS } from "consts";

import { CropMixComposerSettings } from "models";

export const useGetCropMixComposerSettings = () => {
  const { user } = useUserContext();

  return useQuery<CropMixComposerSettings[]>({
    queryKey: [GET_CROP_MIX_COMPOSER_SETTINGS],
    queryFn: async ({ signal }) => {
      const response = await getCropMixComposerSettings({ signal });
      return response || [];
    },
    enabled: !!user && !!user.farm?.id,
  });
};
